export default __webpack_public_path__ + "static/media/vinny bass fingerpick.07465480.wav";